import React, { PropsWithChildren } from "react";
//#region types
import { InlineLabelProps } from "models/propTypes/wintFormPropsTypes";
import InlineLabelLayout from "./inlineLabelLayout";
import Label from "./label";
import Description from "./description";
//#endregion
//#region components
//#endregion

const InlineLabel: React.FC<PropsWithChildren<InlineLabelProps>> = (props) => {
  return (
    <InlineLabelLayout
      columns={props.columns}
      verticalAlignCenter={props.verticalAlignCenter && !props.descriptionText}
      horizontalAlignment={props.horizontalAlignment}
    >
      <Label inline>{props.children}</Label>
      {props.descriptionText ? <Description horizontal>{props.descriptionText}</Description> : <></>}
    </InlineLabelLayout>
  );
};

export default InlineLabel;
